
export class Alert {
  /*
@observable private _alertMessage:string = '';
@computed get hasAlert() {
  return this._alertMessage?true:false
}
@action alert = (message:string) => {
  this._alertMessage= message;
}
@computed get alertMessage() {
  return this._alertMessage;
}
@action clearAlert = () => {
  this._alertMessage = '';
}
*/

  static alert =  (message:string) => {
    alert(message);
  }

}